import React, {useEffect, useState} from 'react'
import {Col, Form, Modal, Row} from 'react-bootstrap'
import {useForm} from 'react-hook-form'
import styled from 'styled-components'
import {tipos} from '../../../../../../services/tipos'
import {actualizarCampo} from '../../../../../../services/campos'

export const ValidatioError = styled.p`
  color: red;
  margin-top: 5px;
`

export const ModalActualizar = ({show, setShow, data, setUpdated, updated, setLimpiar}) => {
  const [datatipos, setDataTipos] = useState('')
  const {register, setValue, handleSubmit, formState, clearErrors} = useForm()

  const {errors} = formState

  useEffect(() => {
    setValue('titulo', data?.titulo)
    setValue('tipo', data?.idtipo)
    setValue('obligatorio', data?.obligatorio)
    setValue('comentario', data?.comentario)
    setValue('editable', data?.editable)
    setValue('visible', data?.visible)
  }, [data])

  useEffect(() => {
    tipos().then((response) => {
      if (response?.success) {
        setDataTipos(response?.data)
      } else {
        console.log('error al obtener los tipos')
      }
    })
  }, [])

  const onSubmit = (datasend) => {
    const {titulo, tipo, obligatorio, comentario, visible, editable} = datasend
    const dataO = {
      idtipo: tipo,
      titulo: titulo,
      obligatorio: obligatorio,
      comentario: comentario,
      editable: editable,
      visible: visible,
    }
    actualizarCampo(dataO,data?._id)
      .then((response) => {
        if (response?.success) {
          console.log('Campo Actualizado')
          setUpdated(!updated)
        } else {
          console.log(response?.message)
        }
      })
      .catch((error) => {
        console.log(error)
      })
    setShow(false)
  }

  const handleCerrar = () => {
    setShow(false)
    setLimpiar('')
  }

  return (
    <Modal
      id='kt_modal_create_app'
      tabIndex={-2}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
      show={show}
      onHide={() => handleCerrar()}
    >
      <div className='modal-header'>
        <h2>Editar Campo</h2>
        {/* begin::Close */}
        <div
          className='btn btn-sm btn-icon btn-active-color-primary'
          onClick={() => handleCerrar()}
        >
          X
        </div>
        {/* end::Close */}
      </div>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <div className='modal-body py-lg-10 px-lg-10'>
          <div className='current' data-kt-stepper-element='content'>
            <div className='w-100'>
              {/*begin::Form Group */}
              <div className='fv-row mb-10'>
                <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                  <span className='required'>Nombre de Campo</span>
                  <i
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Titulo del campo a llenar'
                  ></i>
                </label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  name='titulo'
                  placeholder=''
                  {...register('titulo', {required: true})}
                  autoComplete='off'
                />
                {errors?.nombre && <ValidatioError>Nombre requerido</ValidatioError>}
              </div>
              <div className='fv-row mb-10'>
                <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                  <span className='required'>Comentario</span>
                  <i
                    className='fas fa-exclamation-circle ms-2 fs-7'
                    data-bs-toggle='tooltip'
                    title='Tipo de campo'
                  ></i>
                </label>
                <input
                  type='text'
                  className='form-control form-control-lg form-control-solid'
                  name='comentario'
                  placeholder=''
                  {...register('comentario', {required: true})}
                  autoComplete='off'
                />
                {errors?.descripcion && <ValidatioError>Comentario requerido</ValidatioError>}
              </div>
              <Row>
                <Col>
                  <div className='fv-row mb-10'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>Tipo</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Indica el tipo'
                      ></i>
                    </label>
                    <select
                      className='form-select form-select-sm form-select-solid'
                      data-control='select2'
                      data-placeholder='Latest'
                      data-hide-search='true'
                      {...register('tipo', {required: true})}
                    >
                      {/* <option value="646d44cbc0a8ddf55dadeae3"></option> */}
                      {datatipos && (
                        <>
                          {datatipos?.map((item) => (
                            <option value={item._id} key={item._id}>
                              {item.nombre}
                            </option>
                          ))}
                        </>
                      )}
                    </select>
                  </div>
                </Col>
                <Col>
                  <div className='fv-row mb-10'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>¿Requerido?</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Indica si es campo requerido'
                      ></i>
                    </label>
                    <select
                      className='form-select form-select-sm form-select-solid'
                      data-control='select2'
                      data-placeholder='Latest'
                      data-hide-search='true'
                      {...register('obligatorio', {required: true})}
                    >
                      <option value={false}></option>
                      <option value={true}>Si</option>
                      <option value={false}>No</option>
                    </select>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className='fv-row mb-10'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>¿Es Editable?</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Indica si es campo editable'
                      ></i>
                    </label>
                    <select
                      className='form-select form-select-sm form-select-solid'
                      data-control='select2'
                      data-placeholder='Latest'
                      data-hide-search='true'
                      {...register('editable', {required: true})}
                    >
                      <option value={false}></option>
                      <option value={true}>Si</option>
                      <option value={false}>No</option>
                    </select>
                  </div>
                </Col>
                <Col>
                  <div className='fv-row mb-10'>
                    <label className='d-flex align-items-center fs-5 fw-semibold mb-2'>
                      <span className='required'>¿Es Visible?</span>
                      <i
                        className='fas fa-exclamation-circle ms-2 fs-7'
                        data-bs-toggle='tooltip'
                        title='Indica si es campo visible'
                      ></i>
                    </label>
                    <select
                      className='form-select form-select-sm form-select-solid'
                      data-control='select2'
                      data-placeholder='Latest'
                      data-hide-search='true'
                      {...register('visible', {required: true})}
                    >
                      <option value={false}></option>
                      <option value={true}>Si</option>
                      <option value={false}>No</option>
                    </select>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <button
            type='button'
            className='btn btn-lg btn-danger'
            data-kt-stepper-action='next'
            onClick={() => handleCerrar()}
            style={{marginRight: 20}}
          >
            Cancelar
          </button>
          <button type='submit' className='btn btn-lg btn-primary' data-kt-stepper-action='next'>
            Actualizar
          </button>
        </div>
      </Form>
    </Modal>
  )
}
